import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const Terms = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="pt-20 bg-white">
      <section className="py-20 px-6 lg:px-12 bg-[#ff5200] text-white">
        <div className="max-w-5xl mx-auto text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-7xl font-bold"
          >
            {t.footer.terms}
          </motion.h1>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto prose prose-lg">
          {language === 'de' ? (
            <div className="space-y-8">
              <h2 className="text-3xl font-bold mb-6">Allgemeine Geschäftsbedingungen (AGB) – PIK Agency / Lussho GmbH</h2>
              
              <div>
                <h3 className="text-2xl font-bold mb-3">§1 Geltungsbereich</h3>
                <p>(1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, Leistungen und Angebote zwischen der Lussho GmbH, Sachsenhäuser Landwehrweg 159A, 60599 Frankfurt am Main, Deutschland (nachfolgend „Agentur" genannt, handelnd unter der Marke PIK Agency) und ihren Kunden (nachfolgend „Kunde" genannt).</p>
                <p>(2) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, die Agentur stimmt ihrer Geltung ausdrücklich schriftlich zu.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§2 Vertragsgegenstand und Leistungsarten</h3>
                <p>(1) Die Agentur erbringt kreative, strategische und digitale Dienstleistungen, insbesondere:</p>
                <ul className="list-disc list-inside space-y-2 my-4">
                  <li>Strategische & kreative Kampagnenentwicklung</li>
                  <li>Content- und Kommunikationsstrategien</li>
                  <li>AI-gestützte Content-Produktion (Texte, Bilder, Videos)</li>
                  <li>Experiential Marketing & Event Design</li>
                  <li>E-Commerce & Performance-Marketing</li>
                  <li>Sustainability & Social Impact Projekte</li>
                  <li>Sales Strategy & Business Development</li>
                </ul>
                <p>(2) Die Leistungen können auf der Grundlage eines Dienstvertrags oder eines Werkvertrags erbracht werden:</p>
                <p className="ml-4 my-2"><strong>Dienstvertrag:</strong> Die Agentur schuldet das Tätigwerden, nicht aber den Erfolg (z. B. Beratung, Strategieentwicklung, Betreuung, Social Media Management).</p>
                <p className="ml-4 my-2"><strong>Werkvertrag:</strong> Bei projektbezogenen Leistungen (z. B. Kampagnen, Designs, Websites, Produktionen) wird ein konkretes Ergebnis geschuldet.</p>
                <p>Die jeweilige Vertragsart ergibt sich aus dem Angebot oder der Vereinbarung.</p>
                <p className="mt-4">(3) Bei Event- und Erlebnismarketing-Projekten (z. B. Veranstaltungen, Pop-ups, Installationen) liegt die Verantwortung für Genehmigungen, Sicherheitsauflagen, Versicherungen und Durchführungen beim Kunden, sofern nichts anderes vereinbart ist.</p>
                <p>(4) Bei Nachhaltigkeits- oder Social-Impact-Projekten verpflichtet sich die Agentur zu verantwortungsvollem Handeln und sensibler Kommunikation. Die inhaltliche Verantwortung für Fakten und Aussagen liegt beim Kunden.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§3 Angebote und Vertragsabschluss</h3>
                <p>(1) Angebote der Agentur sind freibleibend und unverbindlich.</p>
                <p>(2) Ein Vertrag kommt erst mit der schriftlichen Bestätigung durch die Agentur oder durch tatsächliche Ausführung der Leistung zustande.</p>
                <p>(3) Änderungen oder Ergänzungen bedürfen der Schriftform.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§4 Vergütung und Zahlungsbedingungen</h3>
                <p>(1) Es gelten die im Angebot oder Vertrag vereinbarten Preise.</p>
                <p>(2) Alle Preise verstehen sich zzgl. der gesetzlichen Umsatzsteuer.</p>
                <p>(3) Zahlungen sind ohne Abzug innerhalb von 14 Tagen nach Rechnungsstellung fällig.</p>
                <p>(4) <strong>Retainer-Vereinbarungen:</strong> Bei laufenden Agenturleistungen werden monatliche Pauschalen (Retainer) vereinbart. Diese sichern die ständige Verfügbarkeit der Agenturkapazitäten. Eine Rückerstattung ungenutzter Stunden erfolgt nicht.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§5 Mitwirkungspflichten des Kunden</h3>
                <p>(1) Der Kunde stellt der Agentur alle für die Durchführung des Projekts erforderlichen Informationen, Inhalte, Materialien und Zugänge rechtzeitig zur Verfügung.</p>
                <p>(2) Verzögert der Kunde die Mitwirkung, verlängern sich vereinbarte Fristen entsprechend.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§6 Leistungszeit und Verzug</h3>
                <p>(1) Liefertermine und Fristen sind nur verbindlich, wenn sie schriftlich bestätigt wurden.</p>
                <p>(2) Bei höherer Gewalt oder unvorhersehbaren Ereignissen ist die Agentur berechtigt, den Liefertermin angemessen zu verschieben.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§7 Nutzungsrechte</h3>
                <p>(1) Die Agentur räumt dem Kunden die im Vertrag vereinbarten Nutzungsrechte an den Arbeitsergebnissen ein.</p>
                <p>(2) Diese Rechte gehen erst nach vollständiger Zahlung der vereinbarten Vergütung auf den Kunden über.</p>
                <p>(3) Bei AI-gestützten Inhalten können Urheberrechte eingeschränkt sein. Die Agentur räumt dem Kunden nur die tatsächlich übertragbaren Rechte ein.</p>
                <p>(4) Der Kunde ist nicht berechtigt, Werke oder Konzepte der Agentur ohne Zustimmung zu verändern oder weiterzugeben.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§8 Online-Konten, Kampagnenmanagement & digitale Zugänge</h3>
                <p>(1) Sofern der Kunde der Agentur Zugang zu Online-Konten (z. B. Meta Business Manager, Google Ads, TikTok Ads, Shopify) gewährt, erfolgt dies ausschließlich zur Erfüllung des Auftrags.</p>
                <p>(2) Die Agentur haftet nicht für Sperrungen, Algorithmusänderungen oder Systemausfälle der jeweiligen Plattformen.</p>
                <p>(3) Alle im Rahmen von Kampagnen erhobenen Daten (Leads, Conversion-Daten etc.) verbleiben im Eigentum des Kunden. Die Agentur darf sie nur zur Optimierung verwenden.</p>
                <p>(4) Der Kunde bleibt Betreiber seiner Plattformen und verantwortlich für deren rechtliche Konformität (Datenschutz, Wettbewerbsrecht, Steuerpflichten).</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§9 Subunternehmer und Drittsysteme</h3>
                <p>(1) Die Agentur ist berechtigt, Subunternehmer oder freie Mitarbeiter zur Leistungserbringung einzusetzen.</p>
                <p>(2) Zur Leistungserbringung können KI-gestützte Tools (z. B. ChatGPT, Midjourney, Adobe Firefly, Runway, Notion AI) oder andere Cloud-Dienste eingesetzt werden.</p>
                <p>(3) Diese werden sorgfältig ausgewählt; eine vollständige Kontrolle über deren Datenverarbeitung außerhalb der EU kann jedoch nicht garantiert werden.</p>
                <p>(4) Der Kunde erklärt sich mit der Nutzung solcher Tools einverstanden, soweit sie für die Vertragserfüllung notwendig sind.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§10 Abnahme</h3>
                <p>(1) Soweit es sich um Werkleistungen handelt, ist der Kunde verpflichtet, die erbrachten Leistungen unverzüglich zu prüfen und abzunehmen.</p>
                <p>(2) Die Abnahme gilt als erfolgt, wenn der Kunde nicht innerhalb von 10 Tagen nach Lieferung schriftlich Mängel rügt.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§11 Haftung</h3>
                <p>(1) Die Agentur haftet nur für Schäden, die auf vorsätzlichem oder grob fahrlässigem Verhalten beruhen.</p>
                <p>(2) Für leichte Fahrlässigkeit haftet die Agentur nur bei Verletzung wesentlicher Vertragspflichten.</p>
                <p>(3) Für Plattformfehler, Änderungen von Algorithmen, Serverausfälle oder technische Störungen bei Drittanbietern (z. B. Meta, Google, TikTok, Shopify) übernimmt die Agentur keine Haftung.</p>
                <p>(4) Für Performance-Ergebnisse, Reichweiten oder Conversion-Ziele wird kein Erfolg garantiert, es sei denn, dies ist ausdrücklich schriftlich vereinbart.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§12 Referenzen und Eigenwerbung</h3>
                <p>(1) Der Kunde gestattet der Agentur, das Projekt sowie das Firmenlogo als Referenz zu verwenden.</p>
                <p>(2) Die Agentur darf anonymisierte Projektdetails (z. B. Kampagnentitel, visuelle Ausschnitte, Ergebnisse) zu Präsentationszwecken und Eigenmarketing nutzen.</p>
                <p>(3) Ein Widerspruch ist nur aus wichtigem Grund möglich und schriftlich mitzuteilen.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§13 Vertraulichkeit</h3>
                <p>Beide Parteien verpflichten sich, sämtliche im Rahmen der Zusammenarbeit erhaltenen Informationen vertraulich zu behandeln.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§14 Schlussbestimmungen</h3>
                <p>(1) Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.</p>
                <p>(2) Erfüllungsort und Gerichtsstand ist Frankfurt am Main.</p>
                <p>(3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
              </div>

              <div className="border-t pt-6 mt-8">
                <p className="text-sm text-gray-600">Stand: November 2025</p>
                <p className="mt-4">
                  Lussho GmbH (handelnd unter der Marke PIK Agency)<br />
                  Sachsenhäuser Landwehrweg 159A<br />
                  60599 Frankfurt am Main<br />
                  hello@pikagency.de
                </p>
              </div>
            </div>
          ) : (
            <div className="space-y-8">
              <h2 className="text-3xl font-bold mb-6">Terms & Conditions</h2>
              
              <div>
                <h3 className="text-2xl font-bold mb-3">§1 Scope</h3>
                <p>(1) These Terms & Conditions (T&C) apply to all contracts, services, and offers between Lussho GmbH, Sachsenhäuser Landwehrweg 159A, 60599 Frankfurt am Main, Germany (hereinafter referred to as "the Agency", operating under the brand PIK Agency) and its clients (hereinafter "the Client").</p>
                <p>(2) Any differing terms of the Client shall not apply unless expressly approved in writing by the Agency.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§2 Scope of Services and Contract Types</h3>
                <p>(1) The Agency provides creative, strategic, and digital communication services, including but not limited to:</p>
                <ul className="list-disc list-inside space-y-2 my-4">
                  <li>Strategic & Creative Campaigns</li>
                  <li>Content Strategy and Development</li>
                  <li>AI-Powered Content Production (text, image, video)</li>
                  <li>Experiential Marketing & Event Design</li>
                  <li>E-Commerce & Performance Marketing</li>
                  <li>Sustainability & Social Impact Projects</li>
                  <li>Sales Strategy & Business Development</li>
                </ul>
                <p>(2) Services may be rendered under either a Service Contract or a Work Contract:</p>
                <p className="ml-4 my-2"><strong>Service Contract:</strong> The Agency is obligated to perform the agreed activities but not to guarantee a specific result (e.g. consulting, strategy development, content creation, ongoing support).</p>
                <p className="ml-4 my-2"><strong>Work Contract:</strong> For project-based deliverables (e.g. campaigns, designs, websites, productions), a defined result is owed.</p>
                <p>The applicable contract type will be specified in the offer or agreement.</p>
                <p className="mt-4">(3) For experiential and event marketing projects (e.g. events, pop-ups, brand activations), the Client is responsible for obtaining necessary permits, safety measures, insurance, and event execution unless otherwise agreed in writing.</p>
                <p>(4) For sustainability or social impact projects, the Agency commits to ethical and responsible communication. The Client remains responsible for the accuracy and legality of all factual or social claims.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§3 Offers and Contract Formation</h3>
                <p>(1) All offers by the Agency are non-binding and subject to change.</p>
                <p>(2) A contract shall only come into effect upon written confirmation by the Agency or commencement of work.</p>
                <p>(3) Any changes or additions must be agreed upon in writing.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§4 Fees and Payment Terms</h3>
                <p>(1) The applicable fees are those specified in the offer or contract.</p>
                <p>(2) All prices are exclusive of applicable VAT.</p>
                <p>(3) Payments are due within 14 days from the date of invoice without any deduction.</p>
                <p>(4) <strong>Retainer Agreements:</strong> For ongoing services, monthly retainers may be agreed upon to ensure continuous agency availability. Unused hours within a retainer period are non-refundable.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§5 Client Responsibilities</h3>
                <p>(1) The Client must provide all necessary information, materials, access, and feedback required for project execution in a timely manner.</p>
                <p>(2) Delays caused by the Client's lack of cooperation may extend agreed deadlines accordingly.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§6 Delivery and Delays</h3>
                <p>(1) Delivery dates are only binding if confirmed in writing.</p>
                <p>(2) In the event of force majeure or unforeseen circumstances, the Agency may reasonably postpone delivery or performance.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§7 Intellectual Property and Usage Rights</h3>
                <p>(1) The Agency grants the Client usage rights to the work results as specified in the contract.</p>
                <p>(2) These rights are transferred only after full payment of all agreed fees.</p>
                <p>(3) For AI-generated or AI-assisted content, intellectual property rights may be limited. The Agency grants only those rights that can legally be transferred.</p>
                <p>(4) The Client may not modify or redistribute any work results without prior written consent from the Agency.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§8 Online Accounts, Campaign Management & Digital Access</h3>
                <p>(1) If the Client grants the Agency access to online accounts (e.g. Meta Business Manager, Google Ads, TikTok Ads, Shopify), such access is provided solely for the execution of the agreed project.</p>
                <p>(2) The Agency shall not be liable for account suspensions, algorithmic changes, or platform malfunctions that affect campaign performance.</p>
                <p>(3) All data collected during campaigns (leads, conversions, analytics, etc.) shall remain the property of the Client and may be used by the Agency only for analysis and optimization purposes.</p>
                <p>(4) The Client remains the legal owner and operator of all digital accounts and is responsible for their compliance with applicable data protection, competition, and tax laws.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§9 Subcontractors and Third-Party Tools</h3>
                <p>(1) The Agency may engage subcontractors or freelancers for service delivery.</p>
                <p>(2) The Agency may use AI-based or cloud-based tools (e.g. ChatGPT, Midjourney, Adobe Firefly, Runway, Notion AI, etc.) as part of its creative and production process.</p>
                <p>(3) Such tools are carefully selected; however, full control over external data processing (especially outside the EU) cannot be guaranteed.</p>
                <p>(4) The Client agrees to the use of such tools insofar as they are necessary to fulfill the contract.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§10 Acceptance</h3>
                <p>(1) In cases of work contracts, the Client must inspect and accept deliverables immediately upon receipt.</p>
                <p>(2) Acceptance is deemed granted if no written notice of defects is submitted within ten (10) days after delivery.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§11 Liability</h3>
                <p>(1) The Agency shall only be liable for damages caused by intent or gross negligence.</p>
                <p>(2) In cases of minor negligence, liability shall be limited to breaches of essential contractual obligations.</p>
                <p>(3) The Agency accepts no liability for platform errors, changes to algorithms, server downtime, or technical failures of third-party providers (e.g. Meta, Google, TikTok, Shopify).</p>
                <p>(4) No guarantee of specific campaign results, conversions, or reach is given, unless expressly agreed in writing.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§12 Reference Rights and Self-Promotion</h3>
                <p>(1) The Client grants the Agency permission to list the project and Client's logo as a reference.</p>
                <p>(2) The Agency may use anonymized project details (titles, visuals, outcomes) for case studies, presentations, and self-promotion.</p>
                <p>(3) The Client may withdraw this permission in writing for valid reasons.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§13 Confidentiality</h3>
                <p>Both parties agree to treat all information and materials exchanged during the collaboration as strictly confidential.</p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-3">§14 Final Provisions</h3>
                <p>(1) German law applies, excluding the UN Convention on Contracts for the International Sale of Goods (CISG).</p>
                <p>(2) Place of performance and jurisdiction is Frankfurt am Main, Germany.</p>
                <p>(3) If any provision of these T&C is or becomes invalid, the validity of the remaining provisions shall not be affected.</p>
              </div>

              <div className="border-t pt-6 mt-8">
                <p className="text-sm text-gray-600">Effective Date: November 2025</p>
                <p className="mt-4">
                  Lussho GmbH (operating as PIK Agency)<br />
                  Sachsenhäuser Landwehrweg 159A<br />
                  60599 Frankfurt am Main, Germany<br />
                  hello@pikagency.de
                </p>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Terms;
